import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var StyledPercentChange = styled.div.withConfig({
  displayName: "partials__StyledPercentChange",
  componentId: "sc-61l3q4-0"
})(["min-width:180px;text-align:left;", ";"], minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    text-align: right;\n  "]))));
export var PercentChangeLabel = styled.span.withConfig({
  displayName: "partials__PercentChangeLabel",
  componentId: "sc-61l3q4-1"
})(["color:rgb(0 0 0 / 0.25);"]);